/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { ControlTable } from '../../../components/Table';
import { cloneDeep, isEmpty } from 'lodash';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';
import { editTaxpayerSchedule, getTaxpayerSchedules, removeTaxpayerSchedule, taxpayerScheduleCategoryList } from '../../../apis/tax-portal/taxpayer';
import TaxCompanyScheduleDetail from './TaxCompanyScheduleDetail';
import useForm from '../../../hooks/useForm';
import { dateToFormat, formatDateHour, getDay } from '../../../utils/date';
import { getParams } from '../../../utils/params';
import Filters from '../../Filters';
import { CARE_COMPANY_MEMO_FILTER_COMPLETED } from '../../../constants/CARE_COMPANY';
import { TAXPAYER_SCHEDULE_VIEW_RANGE_TYPE } from '../../../constants/TaxPortal/TAXPAYER_TYPE';
import Icon from '../../Icon';
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import { isNumber } from 'lodash';
import { custodianPreview } from '../../../utils/custodian';
import { COUNSELING_SEARCH_OPTIONS } from '../../../constants/COUNSELING';

const TaxCompanyScheduleList = (props) => {
  const {
    taxContactType,
    company,
    companies,
    user,
    taxpayerList,
  } = useSelector(
    (store) => ({
      user: store.Profile.user,
      taxContactType: store.TaxPortal.taxContactType,
      company: store.Profile.company,
      companies: store.Data.companies,
      taxpayerList: store.Data.taxpayerList,
    }),
    shallowEqual
  );

  const [schedule, setSchedule] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [formType, setFormType] = useState("create");
  const [myCompany, setMyCompany] = useState({});

  const [rowBtnConfig, setRowBtnConfig] = useState({});

  const [filters, setFilters] = useState([]);
  const [taxpayers, setTaxpayers] = useState([]);
  const [categories, setCategories] = useState([]);


  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (!isEmpty(company) && !isEmpty(taxpayerList)) {
      const managerCompany = companies.find((com) => com.companyIdx === user.managerCompanyIdx);
      setMyCompany(managerCompany);

      setTaxpayers([
        { label: "전체", value: "all" },
        ...taxpayerList.map(item => ({
          ...item, label: item.companyName, value: item.idx
        }))
      ]);

      taxpayerScheduleCategoryList({}).then(res => {
        setCategories([
          { label: "전체", value: "all" },
          ...res.rows.map(item => ({
            ...item, label: item.name, value: item.idx
          }))
        ]);
      });
    }
  }, [company, taxpayerList]);

  const submit = async (_form) => {
    const form = cloneDeep(_form);

    if (form?.search?.categoryIdx === "all") {
      delete form?.search?.categoryIdx;
    }
    if (form?.search?.taxpayerIdx === "all") {
      delete form?.search?.taxpayerIdx;
    }

    if (form.writeEmployee) {
      form.search.writerEmployeeIdx = form.writeEmployee.map(item => item.idx);
      delete form.writeEmployee;
    }

    getTaxpayerSchedules(myCompany?.companyIdx, { ...getParams(form), taxSearchType: taxContactType, })
      .then((res) => {
        const { schedules = [], total = 0, comment } = res.data;
        setList(schedules.map(item => {
          return {
            ...item,
            comments: comment.listByPost.find(c => c.postIdx === item.idx)
          };
        }));
        setTotal(total);
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => setIsLoading(false));
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
  } = useForm({
    offset: 0,
    limit: 10,
    range: {
      date: [getDay(31), getDay(-31)]
    },
    order: [{ createdTime: "desc" }],
    search: {}
  });

  useEffect(() => {
    if (!isEmpty(taxContactType) && !isEmpty(myCompany)) {

      setSubmit(submit);
      submit({ ...form, taxSearchType: taxContactType });
    }

  }, [taxContactType, myCompany]);


  const onSelect = (data, e) => {
    // switch 관련 className 체크
    if (
      !e.target.classList.contains('slider') &&
      !e.target.classList.contains('switch-blue') &&
      e.target?.tagName !== "SPAN"
    ) {
      setSchedule(data);
      setFormType("view");
      setToggle(true);
    }
  };


  useEffect(() => {
    if (!isEmpty(list)) {
      setRowBtnConfig({
        rowButtons: [
          {
            label: "수정",
            type: "edit",
            action: (data) => {
              setSchedule(data);
              setFormType("modify");
              setToggle(true);
            },

          },
          {
            label: "삭제",
            type: "delete",
            action: (data) => {
              systemAlert(`"${data?.title}" 일정을 삭제하시겠습니까?`, {
                buttons: [
                  {
                    color: 'text',
                    label: '취소'
                  },
                  {
                    label: '삭제',
                    color: 'red',
                    onClick: () => {
                      setIsLoading(true);
                      removeTaxpayerSchedule(myCompany.companyIdx, data.idx)
                        .then((res) => {
                          toast.success("삭제가 완료되었습니다.");
                          reSubmit();
                        })
                        .finally(() => {
                          setIsLoading(false);
                        });
                    }
                  }
                ]
              });
            },
          },
        ],
      });
    }

    const fields = [
      {
        title: "작업일",
        key: "date",
        onValue: (d) => dateToFormat(d, formatDateHour)
      },
      {
        title: "제목",
        key: "title"
      },

      {
        title: "카테고리",
        key: "category",
        onValue: (v) => !isEmpty(v) ? v.name : "-"
      },
      {
        title: "노출색상",
        key: "category",
        onValue: (v) => {
          const color = v?.color;
          return (
            !isEmpty(v) ? (
              <>
                <span style={{
                  display: "inline-block",
                  background: color,
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                }} />
              </>
            ) : <span>-</span>
          );
        }
      },
      {
        title: "노출범위",
        key: "viewRange",
        onValue: (v) => TAXPAYER_SCHEDULE_VIEW_RANGE_TYPE.find(f => f.value === v)?.label || "-"
      },
      {
        title: "회사명",
        key: "management",
        onValue: (v) => {
          return (
            v ? (
              <span
                onClick={() => isNumber(v.idx) && custodianPreview(v.idx)}
              >{v.companyName}</span>
            ) : "-"
          );
        }
      },
      {
        title: "담당자",
        width: '80px',
        key: "employee.name"
      },
      {
        title: "처리여부",
        key: "completed",
        width: '80px',
        type: "switch",
        // onValue: (d) => d ? "처리" : "미처리"
        checked: (d) => {
          return d.completed;
        },
        onChange: (e, data) => {
          setIsLoading(true);
          editTaxpayerSchedule(company.managerCompanyIdx, data.idx, { completed: +e.target.checked })
            .then((res) => {
              toast.success('수정되었습니다.');
              reSubmit();
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      },

      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      },
    ];

    setFields(fields);

  }, [list]);

  const tableButtons = [
    {
      label: "일정 등록",
      action: () => {
        setToggle(true);
        setSchedule({});
        setFormType("create");
      }
    }
  ];

  useEffect(() => {
    const _filters = [
      {
        title: "날짜",
        key: 'range.date',
        type: "customdatepicker",
      },
      {
        title: "분류",
        type: "select",
        key: "searchType",
        options: {
          list: COUNSELING_SEARCH_OPTIONS,
        },
      },
      {
        title: "키워드 검색",
        type: "input",
        key: "searchText",
        placeholder: "검색어 입력",
      },
      {
        title: "처리여부",
        type: "select",
        key: "search.completed",
        options: {
          list: CARE_COMPANY_MEMO_FILTER_COMPLETED,
        },
      },
      {
        title: "카테고리",
        type: "select",
        key: "search.categoryIdx",
        options: {
          list: categories,
        },
      },
      ...(company && company.companyType > 1 ? [{
        title: '작성자',
        type: 'searchEmployees',
        key: 'writeEmployee',
        isTax: true,
      }] : []),
      {
        title: "수임처",
        type: "search-select",
        key: "search.taxpayerIdx",
        options: {
          list: taxpayers,
          placeholder: "입력",
          height: "24px",
          zIndex: 100,
          isControlShouldRenderValue: true,
        },
      },
      // {
      //   title: "선택된 수임처",
      //   type: "input",
      //   key: "search.taxpayerIdx",
      //   onValue: (v) => {
      //     return taxpayers?.find(f => f.value === v)?.label || "전체";
      //   },
      //   disabled: true
      // }
    ];

    setFilters(_filters);

  }, [taxpayers, categories]);

  return (
    <div className="tax-portal-schedule">
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isControl={false}
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        buttons={tableButtons}
        onSelect={onSelect}
        rowBtn={rowBtnConfig}
      />
      <TaxCompanyScheduleDetail
        managerCompany={myCompany}
        schedule={schedule}
        setSchedule={setSchedule}
        toggle={toggle}
        setToggle={setToggle}
        formType={formType}
        submit={reSubmit}
        setFormType={setFormType}
      />
    </div>
  );
};

export default TaxCompanyScheduleList;